export const trackerName = 'sp_eco';
export const collectorUrl = 'sp.ecosia.org';
export const forceSecureTracker = true;
